import { Cookies } from '@/enums/cookies.enum';

import axios from 'axios';
import usePopup from '@/composables/usePopup';
import authService from '@/services/auth.service';
import cookieService from '@/services/cookie.service';

// Set X-session header
const session = cookieService.get(Cookies.Session);

if (session) {
    axios.defaults.headers.common['X-session'] = session as string;
}

// Errors handler
const popup = usePopup();
const handledErrors = [400, 401, 403, 404, 409, 500];

export function errorHandler(error?: any) {
    if (!error.response) {
        // Cancelled requests are superseded, not failed: callers that cancel check for a falsy result
        if (axios.isCancel(error)) {
            return;
        }

        if (!window.navigator.onLine) {
            popup.toast.error('Seems that you have no internet connection at this moment', { duration: 10000 });
        }

        // No response at all (network, CORS, ad blocker). Match the handled-error shape so callers
        // destructuring `{ data, status }` take their error path instead of throwing
        return {
            status: 0,
            data: error.message,
        };
    }

    if (handledErrors.includes(error.response.status)) {
        const message = error.response.data.message ? error.response.data.message : error.response.data;

        // If API returns 401 this will clean user session ID and redirect to Login
        if (error.response.status === 401) {
            authService.logout();
        }

        if (error.response.type === 'lead_organization_not_initialized') {
            return;
        }

        return {
            status: error.response.status,
            data: message,
        };
    }

    return error;
}

// Register interceptors
axios.interceptors.response.use(response => {
    return response;
}, error => {
    return errorHandler(error);
});

export default axios;
